interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "FKP";
};

const FKP: Currency = Object.freeze({
  "displayName": "Falkland Islands Pound",
  "numericCode": 238,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "FKP",
  "symbol": "£"
});

export { FKP };
